import axios from "../../../axios";
import StringHelper from "../../../components/helpers/StringHelper";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createSalesSlice = (set, get) => ({
    sales: {
        loading: false,
        filter: {},
        data: [],
        filtered: []
    },
    getSalesInfo: async (params) => {
        const { param } = params;
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ sales: { ...state.sales, loading: true, filter: { ...state.sales.filter, ...param } } }));
        try {
            const resp = await axios({
                method: "post",
                baseURL: config.apiUrls(),
                url: "/v1/business/business-sale-report",
                data: {
                    BranchId: param.branchId,
                    FromDate: param.fromDate,
                    ToDate: param.toDate,
                },
                headers: { token },
            });
            set(state => ({ sales: { ...state.sales, loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ sales: { ...state.sales, loading: false, data: [] } }));
        }
    },
    filterSales: ({ value }) => {
        const DetailReport = get().sales.data?.DetailReport;
        const englishNum = StringHelper.getEnglishNum(value);
        const filtered = DetailReport.filter((item) => (
            (item.BranchName && item.BranchName.includes(value)) ||
            (item.PersonName && item.PersonName.includes(value)) ||
            (item.UserName && item.UserName.toString().includes(englishNum)) ||
            (item.DurationTitle && item.DurationTitle.includes(value)) ||
            (item.CompanyName && item.CompanyName.includes(value))
        ));
        set(state => ({ sales: { ...state.sales, filtered } }));
    },
    getRecalculateBusinessCommission: async (insuranceRequestId) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        const filter = get().sales.filter;
        try {
            await axios({
                method: "post",
                baseURL: config.apiUrls(),
                url: `/v1/business/insurance/recalculate-business-commission/${insuranceRequestId}`,
                headers: { token },
            });
            get().getSalesInfo({ param: filter });
        } catch (error) {
            // Handle error
        }
    },
    getRecalculateMultiple: async (insuranceRequestId) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        const filter = get().sales.filter;
        try {
            await axios({
                method: "post",
                baseURL: config.apiUrls(),
                url: "/v1/business/insurance/recalculate-business-commission-multiple",
                headers: { token },
                data: insuranceRequestId,
            });
            get().getSalesInfo({ param: filter });
        } catch (error) {
            // Handle error
        }
    },
    ClearReportAfterChange: () => {
        set(state => ({
            sales: {
                ...state.sales,
                data: [],
                loading: true
            }
        }));
        setTimeout(() => {
            set(state => ({
                sales: {
                    ...state.sales,
                    loading: false
                }
            }));
        }, 3000);
    },
});
